import { CHECK_EMAIL_HAS_ERRORED, CHECK_EMAIL_SUCCESS } from './types';
import { VERIFICATION_ACCESS_KEY, FEED_URLSRC_EMAIL_VERIFY } from '../constants'
import { globalFetch } from './globalActions';

////////////////////////
// EMAIL VERIFICATION //
////////////////////////


export function clearCheckEmailAddress() {
    return function(dispatch) {
        dispatch({ type: CHECK_EMAIL_SUCCESS, item: {}}); 
    }
}

export function checkEmailAddress(email) {
	return globalFetch({
            urlSrc: FEED_URLSRC_EMAIL_VERIFY,
            extraParams: `?access_key=${VERIFICATION_ACCESS_KEY}&email=${email}`,
			//reducerIsLoading: CHECK_EMAIL_IS_LOADING,
			reducerError: CHECK_EMAIL_HAS_ERRORED,
			dispatchSuccess: (itemObj, dispatch) => {
                dispatch({ type: CHECK_EMAIL_SUCCESS, payload: itemObj}); 
			}
	});
}